module.exports = __webpack_public_path__ + "dab13710badeddf1e0afa869a86fa056.svg";